









import { Component, Mixins, Prop } from "vue-property-decorator";
import { DragKinds } from "./DragKinds";
import { Rectangle, Point, Size } from "../../domain/drawing";
import { DragHandlesMixin } from "./mixins";
import VectorResizeDragHandle from "./VectorResizeDragHandle.vue";
import MoveDragHandle from "./MoveDragHandle.vue";
import MoveDragHandleArea from "./MoveDragHandleArea.vue";

@Component({
  components: {
    VectorResizeDragHandle,
    MoveDragHandle,
    MoveDragHandleArea,
  },
})
export default class VectorDragHandles extends Mixins(DragHandlesMixin) {
  dragFrom: DragKinds = DragKinds.From;
  dragTo: DragKinds = DragKinds.To;

  @Prop()
  from: Point;

  @Prop()
  to: Point;

  get rectangle(): Rectangle {
    return new Rectangle(
      new Point(0, 0),
      this.size
    );
  }

  toMoveHandleLocation(handleSize: Size): Point {
    const difference = this.from.subtract(this.to);
    return new Point(
      (Math.abs(difference.x) - handleSize.width) / 2,
      (Math.abs(difference.y) - handleSize.height) / 2
    );
  }
}
